// extracted by mini-css-extract-plugin
module.exports = {"scrollbar":"Navigation_scrollbar__3ELab","scrollable":"Navigation_scrollable__2bRwt"};